class LayoutUtils {
  static isPassingFFCriteria(rootGetters, ffArray, allow, isOptional) {
    if (!ffArray?.length && !isOptional) {
      return true;
    }

    const hasFeature = (featureFlag) => rootGetters['BusinessStore/hasFeature'](featureFlag);

    if (allow) {
      // Handles 'allowByFFs': all features must be enabled.
      return ffArray.every(hasFeature);
    }

    if (isOptional) {
      // Handles 'optionalByFFs': at least one feature must be enabled.
      return ffArray.some(hasFeature);
    }

    // Handles 'hideByFFs': no features should be enabled.
    return !ffArray.some(hasFeature);
  }

  static shouldShowItemByPermission(rootGetters, permissionsArray, allow) {
    if (permissionsArray && permissionsArray.length > 0) {
      if (allow) {
        return permissionsArray.every((permission) => rootGetters['StaffStore/hasPermission'](permission));
      }
      return !permissionsArray.some((permission) => rootGetters['StaffStore/hasPermission'](permission));
    }
    return true;
  }
}
export default LayoutUtils;
